import { FirebaseOptions, initializeApp } from 'firebase/app';
import { fetchAndActivate, getRemoteConfig, getValue } from 'firebase/remote-config';

import { IS_PROD_ENV } from '@/utils/config';
import { remoteFeatureToggles } from '@/utils/featureToggles';

const prodConfig: FirebaseOptions = {
  apiKey: 'AIzaSyDhUDz0grSS7hu_zOumkMRi3SwzZm_gouE',
  authDomain: 'api-7703238896555888020-368429.firebaseapp.com',
  databaseURL: 'https://api-7703238896555888020-368429.firebaseio.com',
  projectId: 'api-7703238896555888020-368429',
  storageBucket: 'api-7703238896555888020-368429.appspot.com',
  messagingSenderId: '1065048304126',
  appId: '1:1065048304126:web:3b724d4710bfa91fdc38af',
  measurementId: 'G-DNZCDXKF29',
};

const stagingConfig = {
  apiKey: 'AIzaSyBO25I3oyGyAFwjNKKuxCgG6gg6wdOooM0',
  authDomain: 'koppla-dev.firebaseapp.com',
  projectId: 'koppla-dev',
  storageBucket: 'koppla-dev.appspot.com',
  messagingSenderId: '973804507483',
  appId: '1:973804507483:web:ec66d03a4616b540800a7e',
};

const effectiveConfig = IS_PROD_ENV ? prodConfig : stagingConfig;

export const FIREBASE_API_KEY = effectiveConfig.apiKey!;

export function initializeFirebaseApp(): void {
  const app = initializeApp(effectiveConfig);
  const remoteConfig = getRemoteConfig(app);
  // The default and recommended production fetch interval for Remote Config is 12 hours
  // Clear firebase_remote_config indexed DB to force refetch on reload
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  remoteConfig.defaultConfig = {
    web_import_user_access: '[]',
  };

  fetchAndActivate(remoteConfig)
    .then(() => {
      try {
        const importUserIdsString = getValue(remoteConfig, 'web_import_user_access').asString();

        const jsonVal = JSON.parse(importUserIdsString);
        if (Array.isArray(jsonVal)) {
          remoteFeatureToggles.value = {
            ...remoteFeatureToggles.value,
            importUserIds: jsonVal as string[],
          };
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to parse remote config', e);
      }
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch remote config', err);
    });
}

export function getMicrosoftFirebaseApp() {
  return initializeApp(effectiveConfig, 'microsoft');
}
